<template>
  <div class="md:mx-14 mx-4">
    <!-- banner-like -->
    <div
      class="rounded-2xl shadow p-5 mt-10 relative flex flex-col md:flex-row md:items-center justify-between"
    >
      <img
        src="@/assets/images/receive-payment-banner.png"
        alt="banner-background"
        class="absolute left-0 top-0 right-0 bottom-0 w-full h-full"
      />
      <!-- left -->
      <div class="font-light z-10 relative">
        <p>
          You're just a payment away with
          <span class="text-primary font-semibold">Payment Widget</span>
        </p>
        <ul class="text-xs list-disc list-inside my-4">
          <li class="mb-2">Create a payment link</li>
          <li class="mb-2">Share payment link with your customers</li>
          <li class="mb-2">Start receiving payments</li>
        </ul>
      </div>
      <!-- right -->
      <div class="z-10 relative">
        <o-button
          class="text-xs md:text-sm rounded-3xl px-2 bg-primary text-white"
          @click="goToCreatePaymentLink"
          >+ New Payment Link</o-button
        >
      </div>
    </div>
    <!-- table -->
    <payment-link-table :Loading="isLoading" :tableData="paymentLinks" />
  </div>
</template>

<script>
import getPaymentLinks from '@/mixins/paymentLink.js'

export default {
  mixins: [getPaymentLinks],
  data () {
    return {
      isLoading: false,
      payload: {
        page: 1,
        size: 5,
        status: '',
        type: '',
        from: '',
        to: '',
        sort_direction_desc: true,
        sort_by: 'updated_at'
      }
    }
  },
  components: {
    PaymentLinkTable: () =>
      import('@/components/receivePayment/tables/PaymentLinkTable.vue')
  },
  methods: {
    goToCreatePaymentLink () {
      this.$router.push({
        path: '/payment-link',
        query: {
          mode: 'create'
        }
      })
    }
  },
  computed: {
    paymentLinks () {
      return this.$store.state.paymentLink.paymentLinks.items
    }
  },
  async mounted () {
    await this.getPaymentLinks()
  }
}
</script>

<style></style>
